export default __webpack_public_path__ + "static/media/Carousel-image-2.66464097.png";